exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "nano-data .container {\n  padding: 1rem;\n}\n\nnano-data .mat-icon {\n  vertical-align: middle;\n}\n\nnano-data .mat-tab-body-wrapper {\n  -webkit-box-flex: 1;\n      -ms-flex-positive: 1;\n          flex-grow: 1;\n}\n\nnano-data .mat-tab-body.mat-tab-body-active {\n  position: absolute;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader?{"sourceMap":true}!./~/resolve-url-loader!./~/sass-loader/lib/loader.js?sourceMap!./src/app/data/data.component.scss
// module id = 760
// module chunks = 0